export default "__VITE_ASSET__CD9o6awd__"